document.addEventListener('DOMContentLoaded', function(){
  // Data
  const STATES = ["AL","AK","AZ","AR","CA","CO","CT","DC","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"];
  const STATE_RENEWABLE_PCT = {"CA":0.36,"TX":0.28,"IA":0.64,"SD":0.83,"KS":0.47,"OK":0.45,"WA":0.74,"OR":0.60,"ID":0.80,"VT":0.99,"NY":0.33,"MA":0.28,"FL":0.08,"VA":0.12,"NC":0.14,"SC":0.09,"GA":0.09,"AZ":0.12,"NM":0.36,"NV":0.35,"UT":0.13,"CO":0.32,"WY":0.20,"MT":0.45,"ND":0.38,"NE":0.30,"MN":0.31,"WI":0.12,"MI":0.12,"IL":0.14,"IN":0.09,"OH":0.06,"PA":0.08,"NJ":0.08,"CT":0.10,"RI":0.10,"ME":0.70,"NH":0.19,"MD":0.13,"DE":0.08,"DC":0.05,"KY":0.05,"WV":0.06,"LA":0.04,"MS":0.03,"AL":0.13,"AR":0.11,"MO":0.10,"TN":0.13,"HI":0.30};
  const INTENSITIES = { base:1.00, heat:1.24, ac:1.26, water:1.23, dryer:0.31, cooktop:0.04, oven:0.09 }; // kWh/ft²/year
  const PRICING = {500:{HydroWind:12.00,SolarWind:15.00,AllSolar:17.00},1000:{HydroWind:15.00,SolarWind:20.00,AllSolar:25.00},2000:{HydroWind:20.00,SolarWind:30.00,AllSolar:40.00},3000:{HydroWind:25.00,SolarWind:40.00,AllSolar:55.00},4000:{HydroWind:30.00,SolarWind:50.00,AllSolar:70.00},5000:{HydroWind:35.00,SolarWind:60.00,AllSolar:85.00},6000:{HydroWind:40.00,SolarWind:80.00,AllSolar:100.00}};
  const RES_STEPS = [500,1000,2000,3000,4000,5000,6000];
  const CO2_LB_PER_KWH = 0.767209;

  // Elements
  const root = document.getElementById('res-energy-root');
  if (!root) return;

  // Populate States
  const stateSelect = document.getElementById('stateSelect');
  if (stateSelect && stateSelect.options.length === 0) {
    STATES.forEach(s => { const o=document.createElement('option'); o.value=s; o.textContent=s; stateSelect.appendChild(o); });
    stateSelect.value = 'VA';
  }

  // Presets
  const homeType = document.getElementById('homeType');
  const sizeInput = document.getElementById('sizeInput');
  const dontKnowChk = document.getElementById('dontKnowChk');
  const presetRow = document.getElementById('presetRow');
  const presetSelect = document.getElementById('presetSelect');

  function setPresetsFor(home){
    if (!presetSelect) return;
    let opts=[];
    if(home==='Single-Family Home'){
      opts=[['1000','1,000 sqft (XS)'],['1500','1,500 sqft (S)'],['1800','1,800 sqft (M)'],['2200','2,200 sqft (L)'],['3000','3,000 sqft (XL)'],['4000','4,000 sqft (XXL)'],['5000','5,000 sqft (XXXL)']];
    }else if(home==='Multi-Family (Apartment/Condo)'){
      opts=[['500','500 sqft (Studio)'],['750','750 sqft (1BR)'],['1000','1,000 sqft (2BR)'],['1200','1,200 sqft (3BR)']];
    }else if(home==='Tiny Home'){
      opts=[['200','200 sqft (XS)'],['300','300 sqft (S)'],['400','400 sqft (M)']];
    }else{
      opts=[['180','Dorm Room — 180 sqft'],['50','Storage Unit — 50 sqft']];
    }
    presetSelect.innerHTML = opts.map(([v,l])=>`<option value="${v}">${l}</option>`).join('');
  }
  setPresetsFor(homeType.value);

  homeType.addEventListener('change', ()=>{
    setPresetsFor(homeType.value);
    if (dontKnowChk.checked) sizeInput.value = presetSelect.value;
  });
  dontKnowChk.addEventListener('change', ()=>{
    const show = dontKnowChk.checked;
    presetRow.style.display = show ? 'block' : 'none';
    if (show) sizeInput.value = presetSelect.value;
  });
  presetSelect.addEventListener('change', ()=>{
    if (dontKnowChk.checked) sizeInput.value = presetSelect.value;
  });

  // Counters
  const evMinus=document.getElementById('evMinus'), evPlus=document.getElementById('evPlus'), evCount=document.getElementById('evCount');
  const frMinus=document.getElementById('frMinus'), frPlus=document.getElementById('frPlus'), frCount=document.getElementById('frCount');
  const clamp=n=>Math.max(0,Math.floor(n||0));
  evMinus.onclick=()=>evCount.textContent=clamp(+evCount.textContent-1);
  evPlus.onclick=()=>evCount.textContent=clamp(+evCount.textContent+1);
  frMinus.onclick=()=>frCount.textContent=clamp(+frCount.textContent-1);
  frPlus.onclick=()=>frCount.textContent=clamp(+frCount.textContent+1);

  // Review & Pricing
  const scSlider=document.getElementById('scSlider');
  const scPrev=document.getElementById('scPrev');
  const scNext=document.getElementById('scNext');
  const scTicks=document.getElementById('scTicks');
  const priceGrid=document.getElementById('priceGrid');
  const recLead=document.getElementById('recLead');
  const recControls=document.getElementById('recControls');
  const updatePrice=amt=>{
    const p=PRICING[amt];
    priceGrid.innerHTML=p?`
      <div class='plan-card hydrowind'><div class='plan-title'>HydroWind</div><div class='plan-price'>$${p.HydroWind.toFixed(2)}</div><div class='plan-unit'>per mo.</div></div>
      <div class='plan-card solarwind'><div class='plan-title'>SolarWind</div><div class='plan-price'>$${p.SolarWind.toFixed(2)}</div><div class='plan-unit'>per mo.</div></div>
      <div class='plan-card allsolar'><div class='plan-title'>AllSolar</div><div class='plan-price'>$${p.AllSolar.toFixed(2)}</div><div class='plan-unit'>per mo.</div></div>
    `:'';
  };
  const buildResidentialOptions=target=>{
    // Always include full-coverage step first, then lower steps down to 500
    if (!target || target<=0) return [500];
    if (target>6000) return null; // show Business plans
    const STEPS=[500,1000,2000,3000,4000,5000,6000];
    const full = STEPS.find(v => v >= target) || 6000;
    return STEPS.filter(v => v <= full).sort((a,b)=>b-a);
  };

  // Chart
  let supportChartRef=null;
  function renderSupportChart(renBefore,nonRenBefore){
    const canvas=document.getElementById('supportChart'); if (!canvas) return;
    const ctx=canvas.getContext('2d');
    if (supportChartRef) supportChartRef.destroy();
    supportChartRef=new Chart(ctx,{type:'bar',data:{labels:['Renewable Support','Non-Renewable Energy Support'],datasets:[{data:[renBefore,nonRenBefore],backgroundColor:['#10b981','#6b7280']}]},
      options:{plugins:{legend:{display:false},tooltip:{callbacks:{label:(c)=>c.raw.toLocaleString()+' kWh/yr'}}},scales:{y:{beginAtZero:true,title:{display:true,text:'kWh per year'}}}}});
  }

  // Outputs
  const annualKWhEl=document.getElementById('annualKWh'), monthlyKWhEl=document.getElementById('monthlyKWh');
  const stateRenewablePctEl=document.getElementById('stateRenewablePct'), stateRenewableNoteEl=document.getElementById('stateRenewableNote');
  const annualNonRenKWhEl=document.getElementById('annualNonRenKWh'), monthlyNonRenKWhEl=document.getElementById('monthlyNonRenKWh');
  const annualCO2El=document.getElementById('annualCO2'), annualCO2mtEl=document.getElementById('annualCO2mt');
  const monthlyCO2NonRenEl=document.getElementById('monthlyCO2NonRen'), monthlyCO2NonRenMtEl=document.getElementById('monthlyCO2NonRenMt');
  const assumptionsEl=document.getElementById('assumptions');

  function compute(){
    const area=Math.max(0, Number((document.getElementById('sizeInput')||{}).value || 0));
    const stateCode=(document.getElementById('stateSelect')||{}).value || 'VA';
    const renShare=(STATE_RENEWABLE_PCT[stateCode]!=null)?STATE_RENEWABLE_PCT[stateCode]:0.2;

    let kwhPerSqftYr=1.00;
    ['heat','ac','water','dryer','cooktop','oven'].forEach(id=>{ const el=document.getElementById(id); if(el&&el.checked){ kwhPerSqftYr+=INTENSITIES[id]; }});

    let annualKWh=kwhPerSqftYr*area;
    let monthlyKWh=annualKWh/12;

    const evs = Math.max(0,Number((document.getElementById('evCount')||{}).textContent)||0);
    const frs = Math.max(0,Number((document.getElementById('frCount')||{}).textContent)||0);
    monthlyKWh += evs*197 + frs*50;
    annualKWh = monthlyKWh*12;

    const annualNonRen=annualKWh*(1-renShare);
    const monthlyNonRen=monthlyKWh*(1-renShare);

    const annualCO2_lbs=annualNonRen*CO2_LB_PER_KWH;
    const monthlyCO2_lbs=monthlyNonRen*CO2_LB_PER_KWH;

    annualKWhEl.textContent=Math.round(annualKWh).toLocaleString()+' kWh';
    monthlyKWhEl.textContent=Math.round(monthlyKWh).toLocaleString()+' kWh';
    stateRenewablePctEl.textContent=(renShare*100).toFixed(0)+'%';
    stateRenewableNoteEl.innerHTML=stateCode+' renewable share (wind/solar/hydro/geothermal). <a href="https://www.epa.gov/egrid/summary-data" target="_blank" rel="noopener">Source: EPA eGRID Summary Data</a>';
    annualNonRenKWhEl.textContent=Math.round(annualNonRen).toLocaleString()+' kWh';
    monthlyNonRenKWhEl.textContent=Math.round(monthlyNonRen).toLocaleString()+' kWh';
    annualCO2El.textContent=Math.round(annualCO2_lbs).toLocaleString()+' lb CO₂';
    annualCO2mtEl.textContent='≈ '+(annualCO2_lbs/2204.62).toFixed(1)+' metric tons / year (non-renewables)';
    monthlyCO2NonRenEl.textContent=Math.round(monthlyCO2_lbs).toLocaleString()+' lb CO₂';
    monthlyCO2NonRenMtEl.textContent='≈ '+(monthlyCO2_lbs/2204.62).toFixed(1)+' metric tons / month';
    assumptionsEl.textContent=`Home=${homeType.value}; State=${stateCode}; Area=${area.toLocaleString()} ft²; EVs=${evs}; ExtraFridge=${frs}.`;

    // Review Your Options
    const options=buildResidentialOptions(monthlyNonRen);
    const scSlider=document.getElementById('scSlider');
    const scPrev=document.getElementById('scPrev');
    const scNext=document.getElementById('scNext');
    const scTicks=document.getElementById('scTicks');
    const recLead=document.getElementById('recLead');
    const recControls=document.getElementById('recControls');

    if (options===null){
      recLead.innerHTML='Non-renewable usage exceeds 6,000 kWh per month. Please use our <strong>Business plans</strong>.';
      recControls.style.display='none';
    } else {
      recControls.style.display='block';
      scSlider.min=0; scSlider.max=options.length-1; scSlider.value=0;
      const amt=options[0];
      recLead.innerHTML=`<strong>${amt.toLocaleString()} kWh/mo.</strong> covers ${Math.min(100,Math.round((amt/monthlyNonRen)*100))}% of non-renewable use`;
      scTicks.style.gridTemplateColumns=`repeat(${options.length}, minmax(0,1fr))`;
      scTicks.innerHTML=options.map((v,i)=>`<span class='tick ${i===0?'active':''}' data-idx='${i}'>${v.toLocaleString()} kWh</span>`).join('');
      updatePrice(amt);
      scTicks.onclick=e=>{const t=e.target.closest('[data-idx]'); if(!t) return; scSlider.value=Number(t.dataset.idx); scSlider.dispatchEvent(new Event('input'));};
      scPrev.onclick=()=>{ scSlider.value=Math.max(+scSlider.min,+scSlider.value-1); scSlider.dispatchEvent(new Event('input')); };
      scNext.onclick=()=>{ scSlider.value=Math.min(+scSlider.max,+scSlider.value+1); scSlider.dispatchEvent(new Event('input')); };
      scSlider.oninput=()=>{ const i=Number(scSlider.value); const val=options[i] ?? options[0]; scTicks.querySelectorAll('.tick').forEach((el,ix)=>el.classList.toggle('active',ix===i)); recLead.innerHTML=`<strong>${val.toLocaleString()} kWh/mo.</strong> covers ${Math.min(100,Math.round((val/monthlyNonRen)*100))}% of non-renewable use`; updatePrice(val); };
    }

    // Chart
    renderSupportChart(annualKWh*renShare, annualNonRen);
  }

  document.getElementById('calcBtn').addEventListener('click', compute);
  document.getElementById('resetBtn').addEventListener('click', ()=>{
    homeType.value='Single-Family Home'; setPresetsFor('Single-Family Home');
    stateSelect.value='VA';
    sizeInput.value=1000;
    dontKnowChk.checked=false; presetRow.style.display='none';
    ['heat','ac','water','dryer','cooktop','oven'].forEach(id=>{ const el=document.getElementById(id); if(el) el.checked=false; });
    document.getElementById('evCount').textContent='0';
    document.getElementById('frCount').textContent='0';
    ['annualKWh','monthlyKWh','stateRenewablePct','annualNonRenKWh','monthlyNonRenKWh','annualCO2','monthlyCO2NonRen'].forEach(id=>{ const el=document.getElementById(id); if(el) el.textContent='—'; });
    ['annualCO2mt','monthlyCO2NonRenMt','assumptions'].forEach(id=>{ const el=document.getElementById(id); if(el) el.textContent='—'; });
    if (supportChartRef){ supportChartRef.destroy(); supportChartRef=null; }
    document.getElementById('recLead').textContent='Pick an increment to match your non-renewable monthly usage.';
    document.getElementById('recControls').style.display='block';
    document.getElementById('scTicks').innerHTML='';
    document.getElementById('priceGrid').innerHTML='';
  });
});
